const getters = {

    Authorization   : state => state.user.Authorization,
    corpId          : state => state.user.corpId,
    agentId         : state => state.user.agentId,
    timestamp       : state => state.user.timestamp,
    noncestr        : state => state.user.noncestr,
    companySignature: state => state.user.companySignature,
    signature       : state => state.user.signature

}
export default getters
